// src/components/Head.jsx

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
// const canonicalUrl = typeof window !== 'undefined' 
//   ? `https://atocreative.et${window.location.pathname}`
//   : url;
const HeadComponent = ({
  title = "Ato Creative | Creative Marketing Services for businesses",
  description = "Looking for creative marketing services tailored for businesses? Ato Creative offers affordable branding, content creation, and web development to boost your business.",
  keywords = "creative marketing for businesses, affordable branding, business web development, content creation services, business marketing solutions",
  url = "https://atocreative.et/",
  image = "https://atocreative.et/logo.png",
  lang = "en",
}) => {
  const GA_MEASUREMENT_ID = 'G-V0V5XB0K2C';
  const canonicalUrl = typeof window !== 'undefined' 
    ? `https://atocreative.et${window.location.pathname}`
    : url;

  useEffect(() => {
    // Google Analytics initialization
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', GA_MEASUREMENT_ID, {
        page_path: window.location.pathname,
        transport_type: 'beacon',
        anonymize_ip: true
      });
    }
  }, []);
// const SMARTSUPP_KEY = '5a8f3bde824a31e84627dd0fbab9f6aac6442862';
const SMARTSUPP_KEY = 'e7fc34209e43bab140fa11f940e93af36f25b686';
  return (
    <Helmet htmlAttributes={{ lang }}>
      {/* Primary Meta Tags */}
<meta name="viewport" content="width=device-width,initial-scale=1"/>


      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Ato Creative" />
      <meta http-equiv="Cross-Origin-Opener-Policy" content="same-origin-allow-popups"></meta>
      
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Ato Creative" />
      <meta property="og:locale" content={lang === 'en' ? 'en_US' : lang.toUpperCase()} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={`${title} - Ato Creative`} />
      <meta name="twitter:site" content="@AtoCreative" />
      <meta name="twitter:creator" content="@AtoCreative" />
      <meta name="twitter:domain" content="atocreative.et" />
      {/* facebook confirm */}
      <meta name="facebook-domain-verification" content="n1s6n0pofnmri4aauqq24xr10w7clp" />
      {/* Canonical */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Favicons */}
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.jpg" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.jpg" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.jpg" />
      <link rel="manifest" href="/site.webmanifest" />
      
      {/* Preconnects */}
      <link rel="preconnect" href="https://www.googletagmanager.com" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      
      {/* Google Analytics */}
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`} />
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', {
            page_path: window.location.pathname,
            transport_type: 'beacon',
            anonymize_ip: true
          });
        `}
      </script>
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Ato Creative",
          "url": url,
          "logo": image,
          "sameAs": [
            "https://www.facebook.com/AtoCreative",
            "https://twitter.com/AtoCreative",
            "https://www.linkedin.com/company/atocreative",
            "https://instagram.com/AtoCreative"
          ],
          "contactPoint": [{
            "@type": "ContactPoint",
            "telephone": "+251925401353",
            "contactType": "customer service",
            "areaServed": ["ET"],
            "availableLanguage": ["English"]
          }],
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "ET"
          }
        })}
      </script>
      
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": title,
          "description": description,
          "url": canonicalUrl,
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${url}search?q={search_term_string}`,
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
      

      <script type="text/javascript">
        {`
          var _smartsupp = _smartsupp || {};
          _smartsupp.key = '${SMARTSUPP_KEY}';
          window.smartsupp||(function(d) {
            var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];
            s=d.getElementsByTagName('script')[0];c=d.createElement('script');
            c.type='text/javascript';c.charset='utf-8';c.async=true;
            c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);
          })(document);
        `}
      </script>
      {/* <noscript>Powered by <a href="https://www.smartsupp.com" target="_blank">Smartsupp</a></noscript> */}
      {/* PWA */}
      <meta name="theme-color" content="#FD5F20" />
      <meta name="apple-mobile-web-app-title" content="Ato Creative" />
      <meta name="application-name" content="Ato Creative" />
      <meta name="msapplication-TileColor" content="#FD5F20" />
    </Helmet>
  );
};

HeadComponent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  lang: PropTypes.string,
};

export default HeadComponent;